import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import JoinOurCommunity from "./sections/JoinOurCommunity";
import TurnkeySolutions from "./sections/TurnkeySolutions";
import DomandeFrequenti from "./sections/DomandeFrequenti";
import DrainServicesGrid from "./sections/DrainServicesGrid";
import FreeInspections from "./sections/FreeInspections";
import ExploreServices from "./sections/ExploreServices";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <JoinOurCommunity />
      <TurnkeySolutions />
      <DomandeFrequenti />
      <DrainServicesGrid />
      <FreeInspections />
      <ExploreServices />
      <Footer />
    </div>;
}